
import React, { Fragment } from "react";
import { AuditListItem } from "./AuditsListItem";
import { RenderAuditItem } from "../RenderAuditItem";
import "./_AuditList.less";


interface AuditsListProps {
    audits: number[];
};

export const AuditsList: React.FC<AuditsListProps> = ({ audits }) => {
    return (
        <Fragment>
            {audits.map((id) => (
                <RenderAuditItem itemId={id}
                    render={({ item }) => (
                        <AuditListItem key={id} item={item} />
                    )}
                />
            ))}
        </Fragment>
    );
};
